import React from "react";
import styles from "./Normative.module.scss";
import CardRow from "../../components/_shared/card-row/CardRow";

const NormativeActs_data = [
  {
    title: "STATUTI I FEDERATËS SË FUTBOLLIT TË KOSOVËS",
    navigationLink: {
      title: "lexo dokument",
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/STATUTI%20I%20FEDERATA%CC%83_S%20SA%CC%83_%20FUTBOLLIT%20TA%CC%83_%20KOSOVES.pdf"
    },
  },
  {
    title: "Rregullorja e Garave e Superligës dhe Kupës edicioni - 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20e%20Garave%20te%CC%88%20Superlige%CC%88s%20dhe%20Kupe%CC%88s%20se%CC%88%20Kosove%CC%88s%20Edicioni%202026%202027.pdf"
      },
  },
  {
    title: "Rregullorja e Garave e Ligës së Parë dhe Kupës edicioni - 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20e%20Garave%20te%CC%88%20Lige%CC%88s%20se%CC%88%20Pare%CC%88%20dhe%20Kupe%CC%88s%20se%CC%88%20Kosove%CC%88s%20Edicioni%202026%202027.pdf"
    },
  },
  {
    title: "Rregullorja e Garave e Ligës së Dytë dhe Kupës edicioni - 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20e%20Garave%20te%CC%88%20Lige%CC%88s%20se%CC%88%20Dyte%CC%88%20dhe%20Kupe%CC%88s%20se%CC%88%20Kosove%CC%88s%20Edicioni%202026%202027.pdf"
    },
  },
  {
    title: "Rregullore e Garave të Ligës së Tretë dhe Kupës së Kosovës Edicioni 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20e%20Garave%20te%CC%88%20Lige%CC%88s%20se%CC%88%20Trete%CC%88%20dhe%20Kupe%CC%88s%20se%CC%88%20Kosove%CC%88s%20Edicioni%202026%202027.pdf"
    },
  },
  // {
  //   title: "Rregullorja e Garave e Superligës U21 edicioni - 2025/2026",
  //   navigationLink: {
  //     link: "https://minio.linkplus.dev:9000/ffk/PDFs/RREGULLORE%20E%20GARAVE%20TE%CC%88%20SUPERLIGE%CC%88S%20U%2021%20-Edicioni%202025-2026.pdf"
  //   },
  // },
  {
    title:
        "Rregullorja e Garave për kategoritë U-19, U-17, U-15, U-13, U-11 dhe U-9 edicioni - 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20e%20Garave%20te%CC%88%20Kategorive%20U-19%2C%20U-17%2C%20U-15%2C%20U-13%2C%20U-11%20DHE%20U-9%20Edicioni%202026%202027%20.pdf"
    },
  },
  {
    title: "Kodi i Disiplinës dhe Etikës 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Kodi%20i%20Disiplines%20dhe%20Etikes%20edicioni%202026%202027.pdf",
    },
  },
  {
    title: "Protokolli i VAR-it",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/3.-PROTOKOLI-I-VAR-it-2.pdf",
    },
  },
  {
    title: "Rregullore e Garave të Kampionatit dhe Kupes se Kosoves (Vajzat) edicioni  - 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20e%20Garave%20te%CC%88%20Kampionatit%20dhe%20Kupes%20se%20Kosoves%20%28Vajzat%29%20Edicioni%202026-2027%20%281%29.pdf"
    },
  },
  {
    title: "Rregullorja e garave të Futsallit - 2026/2027",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullorja%20e%20Garave%20%281%29.docx.pdf",
    },
  },
  {
    title: "Rregullore për regjistrimin, statusin dhe transferin e lojtarëve",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Rregullore%20mbi%20Regjistrimin%2C%20Statusin%20dhe%20Transferin%20e%20Lojtareve%202026.pdf"
    },
  },
  // {
  //   title: "Rregullorja e UEFA-s për infrastrukturën e stadiumeve",
  //   navigationLink: {
  //     link: "",
  //   },
  // },
  {
    title: "Politika mbi mbrojtjen dhe sigurinë e fëmijëve në futboll",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/POLITIKA%20MBI%20MBROJTJEN%20DHE%20SIGURINE%20E%20FEMIJEVE%20NE%20FUTBOLL.pdf",
    },
  },
];

const NormativeActs = () => {
  return (
      <div className={styles.MainWrapper}>
        <div className={styles.PrimaryTitleWrapper}>
          <h1>Aktet Normative</h1>
        </div>
        <div className={styles.ListWrapper}>
          {NormativeActs_data.map((data, index) => (
              <CardRow
                  key={index}
                  data={{
                    ...data,
                    id: index + 1,
                    navigationLink: {
                      ...data.navigationLink,
                      link: "Lexo Dokumentin",
                      onLinkClick: () =>
                          window.open(data.navigationLink?.link, "_blank"),
                    },
                  }}
                  colors="INVERTED"
              />
          ))}
        </div>
      </div>
  );

};

export default NormativeActs;
